import React, { useContext, useEffect, useState } from "react";
import Minicart from "../Minicart";
import { Link, useNavigate } from "react-router-dom";
import { DataContext } from "../../DataContext/DataContext";
import { useDispatch, useSelector } from "react-redux";
import { getWishlistTotal } from "../../redux/actions/wishListActon";

function Hmain() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setSelectedCategory } = useContext(DataContext);
  const totalItems = useSelector((state) => state.wishlist.totalItems);

  useEffect(() => {
    dispatch(getWishlistTotal());
  }, [dispatch]);

  const [query, setQuery] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const userState = useSelector((state) => state?.auth);

  const handleInputChange = (e) => {
    const newQuery = e.target.value;
    setQuery(newQuery);
    navigate(`/search?query=${newQuery}`);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800;900&display=swap');

        @keyframes hmFadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ─── Navbar shell ─── */
        .hmain-header {
          background: #14b8a6;
          position: sticky;
          top: 0;
          z-index: 1000;
          height: auto;
          min-height: 60px;
          display: flex;
          flex-direction: column;
          box-shadow: 0 4px 20px rgba(0,0,0,0.12);
          transition: all 0.3s ease;
        }

        .hmain-top-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          max-width: 1400px;
          margin: 0 auto;
          padding: 10px 20px;
          gap: 16px;
        }

        @media (max-width: 767px) {
          .hmain-top-row {
            padding: 8px 12px;
            gap: 10px;
          }
        }

        /* ─── Mobile hamburger ─── */
        .hmain-burger {
          display: none;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 10px;
          color: white;
          text-decoration: none;
          transition: background 0.2s;
          flex-shrink: 0;
        }
        .hmain-burger:hover { background: rgba(255,255,255,0.15); color: white; }

        @media (max-width: 991px) { .hmain-burger { display: none !important; } }

        /* ─── Logo ─── */
        .hmain-logo-link {
          display: flex;
          align-items: center;
          gap: 12px;
          text-decoration: none;
          flex-shrink: 0;
        }

        .hmain-logo-circle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px solid rgba(255,255,255,0.8);
          overflow: hidden;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: box-shadow 0.2s, transform 0.3s;
          box-shadow: 0 2px 10px rgba(0,0,0,0.15);
        }

        .hmain-logo-link:hover .hmain-logo-circle {
          box-shadow: 0 4px 20px rgba(0,0,0,0.2);
          transform: scale(1.05);
        }

        .hmain-logo-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .hmain-brand {
          display: flex;
          flex-direction: column;
          line-height: 1;
        }

        .hmain-brand-name {
          font-family: 'Inter', sans-serif;
          font-size: 20px;
          font-weight: 900;
          color: white;
          letter-spacing: -0.5px;
          text-transform: uppercase;
          white-space: nowrap;
          line-height: 1;
        }

        .hmain-brand-sub {
          font-family: 'Inter', sans-serif;
          font-size: 8px;
          font-weight: 700;
          color: rgba(255,255,255,0.7);
          letter-spacing: 1.5px;
          text-transform: uppercase;
          margin-top: 1px;
        }

        @media (max-width: 767px) {
          .hmain-brand-name { font-size: 16px; }
          .hmain-brand-sub { display: none; }
          .hmain-logo-circle { width: 34px !important; height: 34px !important; }
          .hmain-actions { gap: 6px !important; }
        }

        /* ─── Search ─── */
        .hmain-search-wrap {
          flex: 1;
          max-width: 600px;
          margin: 0 auto;
          transition: all 0.3s ease;
        }

        .hmain-mobile-search-row {
          display: none;
        }

        @media (max-width: 991px) { 
          .hmain-mobile-search-row {
            display: block;
            width: 100%;
            padding: 0 12px 10px 12px;
          }
          .hmain-search-box {
            padding: 4px 14px;
            border-radius: 12px;
            height: 40px;
            background: rgba(255,255,255,0.22);
          }
          .hmain-search-input {
            font-size: 13px;
          }
          .hmain-search-btn {
            width: 32px; height: 32px;
          }
        }

        .hmain-search-box {
          display: flex;
          align-items: center;
          background: rgba(255,255,255,0.18);
          border: 1.5px solid rgba(255,255,255,0.25);
          border-radius: 12px;
          padding: 3px 4px 3px 14px;
          transition: all 0.25s ease;
        }

        .hmain-search-box:focus-within {
          background: rgba(255,255,255,0.28);
          border-color: white;
          box-shadow: 0 0 0 4px rgba(255,255,255,0.12);
        }

        .hmain-search-input {
          flex: 1;
          background: transparent;
          border: none;
          outline: none;
          color: white;
          font-size: 14px;
          font-family: 'Inter', sans-serif;
          padding: 7px 0;
        }

        .hmain-search-input::placeholder { color: rgba(255,255,255,0.65); }

        .hmain-search-btn {
          background: white;
          color: #14b8a6;
          border: none;
          width: 36px;
          height: 36px;
          border-radius: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }

        .hmain-search-btn:hover {
          background: #f0fdfa;
          transform: scale(1.06);
        }

        /* ─── Actions ─── */
        .hmain-actions {
          display: flex;
          align-items: center;
          gap: 4px;
          list-style: none;
          margin: 0;
          padding: 0;
          flex-shrink: 0;
        }

        .hmain-action-btn {
          width: 40px; height: 40px;
          display: flex; align-items: center; justify-content: center;
          border-radius: 12px;
          color: white;
          background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.1);
          transition: all 0.2s;
          cursor: pointer;
        }
        .hmain-action-btn:hover { background: rgba(255,255,255,0.18); transform: translateY(-1px); }
        .hmain-action-btn.wishlist-btn { position: relative; }

        .hmain-action-badge {
          position: absolute;
          top: 5px;
          right: 5px;
          background: #fbbf24;
          color: #1e293b;
          font-size: 9px;
          font-weight: 900;
          min-width: 16px;
          height: 16px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #14b8a6;
          line-height: 1;
        }

        .hmain-icon-btn {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          color: white;
          text-decoration: none;
          background: transparent;
          border: none;
          cursor: pointer;
          transition: background 0.2s;
          position: relative;
        }

        .hmain-icon-btn:hover {
          background: rgba(255,255,255,0.15);
          color: white;
        }

        .hmain-badge {
          position: absolute;
          top: 5px;
          right: 5px;
          background: #fbbf24;
          color: #1e293b;
          font-size: 9px;
          font-weight: 900;
          min-width: 16px;
          height: 16px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #14b8a6;
          line-height: 1;
        }

        .hmain-login-btn {
          padding: 8px 18px;
          background: white;
          color: #14b8a6;
          font-size: 13px;
          font-weight: 800;
          border-radius: 10px;
          text-decoration: none;
          transition: all 0.2s ease;
          white-space: nowrap;
          font-family: 'Inter', sans-serif;
        }

        .hmain-login-btn:hover {
          background: #f0fdfa;
          transform: translateY(-1px);
          color: #0d9488;
        }

        /* ─── User dropdown ─── */
        .hmain-dropdown-wrap {
          position: absolute;
          right: 0;
          top: calc(100% + 10px);
          z-index: 10000;
          animation: hmFadeIn 0.2s ease;
        }

        .hmain-dropdown-card {
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(0,0,0,0.15), 0 4px 12px rgba(0,0,0,0.08);
          border: 1px solid #f1f5f9;
        }

        @media (max-width: 991px) {
          .hmain-hide-mobile { display: none !important; }
          .hmain-actions { gap: 8px; }
          .hmain-logo-link { gap: 10px; }
        }
      `}</style>

      <div className="hmain-header">
        <div className="hmain-top-row">
          {/* Logo + Brand name */}
          <Link className="hmain-logo-link" to="/">
            <div className="hmain-logo-circle">
              <img
                className="hmain-logo-img"
                src="/logo3.png"
                alt="Pulse Addis"
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </div>
            <div className="hmain-brand">
              <span className="hmain-brand-name">Pulse Addis</span>
              <span className="hmain-brand-sub">Pharmacy</span>
            </div>
          </Link>

          {/* Search bar - Hidden on mobile, shown in its own row below */}
          <div className="hmain-search-wrap hmain-hide-mobile">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="hmain-search-box">
                <input
                  className="hmain-search-input"
                  placeholder="Search medicines, vitamins, OTC..."
                  type="text"
                  value={query}
                  onChange={handleInputChange}
                />
                <button
                  className="hmain-search-btn"
                  type="submit"
                  aria-label="Search"
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                </button>
              </div>
            </form>
          </div>

          {/* Action icons */}
          <div className="hmain-actions">
            {/* Account / Login */}
            {userState?.user ? (
              <Link
                to="/myaccount"
                className="hmain-action-btn"
                aria-label="Account"
              >
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </Link>
            ) : (
              <Link to="/login" className="hmain-action-btn">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </Link>
            )}

            {/* Wishlist - Hidden on small mobile but kept in Hmain for larger screens */}
            <Link
              className="hmain-action-btn hmain-hide-mobile"
              to="/wishlist"
              aria-label="Wishlist"
            >
              <div style={{ position: "relative" }}>
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
                {totalItems > 0 && (
                  <span className="hmain-action-badge">{totalItems}</span>
                )}
              </div>
            </Link>

            {/* Cart */}
            <Minicart />
          </div>
        </div>

        {/* Mobile Search - Only visible on smaller screens */}
        <div className="hmain-mobile-search-row">
           <form onSubmit={(e) => e.preventDefault()} style={{ display: 'flex', justifyContent: 'center' }}>
            <div className="hmain-search-box" style={{ width: '100%', maxWidth: 'none' }}>
              <input
                className="hmain-search-input"
                placeholder="Search medicines, vitamins..."
                type="text"
                value={query}
                onChange={handleInputChange}
              />
              <button
                className="hmain-search-btn"
                type="submit"
                aria-label="Search"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Hmain;
